var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPollTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.60207 8.1325L2.09207 8.3025C2.02846 8.32376 1.97122 8.36067 1.9256 8.40984C1.87999 8.45901 1.84747 8.51886 1.83104 8.58389C1.81461 8.64891 1.81479 8.71703 1.83157 8.78196C1.84835 8.8469 1.88119 8.90658 1.92707 8.9555L6.52357 13.862C6.59949 13.943 6.69146 14.0074 6.79361 14.051C6.89576 14.0945 7.00586 14.1163 7.11691 14.115C7.22795 14.1137 7.33751 14.0893 7.4386 14.0433C7.53969 13.9973 7.6301 13.9308 7.70407 13.848L16.1516 4.39C16.1925 4.34411 16.2222 4.28942 16.2386 4.23017C16.2549 4.17092 16.2573 4.10871 16.2457 4.04835C16.2341 3.988 16.2088 3.93113 16.1716 3.88216C16.1345 3.8332 16.0866 3.79345 16.0316 3.766L15.9826 3.741C15.84 3.66978 15.6794 3.64277 15.5213 3.66344C15.3633 3.6841 15.215 3.75151 15.0956 3.857L7.00007 11L3.33507 8.2515C3.23161 8.17389 3.11088 8.12252 2.98322 8.1018C2.85556 8.08107 2.72477 8.09161 2.60207 8.1325Z",
    fill: "#5089FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollTick);
export default __webpack_public_path__ + "static/media/poll-tick.0e0ed2ec230f9902f5b4176ffc1a57e9.svg";
export { ForwardRef as ReactComponent };